import { css, html } from 'lit';
import { ifDefined } from 'lit-html/directives/if-defined.js';
import { customElement, property, state } from 'lit/decorators.js';
import { BaseComponent } from '../../features/base-component/base-component';
import { PLACEMENT_TOP } from '../../common/constants/bs';
import { bs5Connect } from '../../common/bs5Utils/bs5.mixin';

/**
 * A static element to display content in a popover.
 */
@customElement('mhecomm-popover')
export class Popover extends bs5Connect(BaseComponent) {
  static styles = [
    css`
      :host {
        display: block;
      }
    `,
  ];

  /**
   * The label of the link.
   */
  @property()
  label?: string;

  /**
   * The icon to use.
   */
  @property()
  icon?: string;

  /**
   * The title that appears inside the tooltip.
   */
  @property()
  heading?: string;

  /**
   * The text that appears inside of the tooltip.
   */
  @property()
  text = '';

  /**
   * The placement of the tooltip: bottom, top, left, or right.
   */
  @property()
  placement = PLACEMENT_TOP;

  /**
   * A11y button name for screen readers.
   */
  @property()
  ariaLabel = '';

  /**
   * If true, Link underline will be disabled.
   */
  @property({ type: Boolean })
  disableLinkUnderline?: boolean;

  /**
   * Icon color to display.
   */
  @property()
  iconColor = 'default';

  /**
   * Icon size to display.
   */
  @property()
  iconSize = 'default';

  /**
   * Popover Instance.
   */
  @state()
  popoverInstance: any;

  private selector = '[data-bs-toggle="popover"]';

  renderComp() {
    return html`
      <button
        id="${ifDefined(this.id ? "link-" + this.id : undefined)}"
        class="btn btn-link p-0 mb-1 ${this.disableLinkUnderline ? 'border-0' : 'link-primary-underline'}"
        data-bs-toggle="popover"
        data-bs-html="true"
        title=${this.heading || ''}
        aria-label=${ifDefined(this.ariaLabel)}
        aria-expanded="false"
        data-bs-placement=${this.placement}
        data-bs-content=${this.text || ' '}
      >
        ${this.uxtIconReady && this.icon
          ? html`<uxt-icon icon="${this.icon}" color=${this.iconColor} size=${this.iconSize} aria-hidden="true"></uxt-icon>`
          : ''}
        ${this.label ? this.label : ''}
      </button>
    `;
  }

  updated() {
    this.popoverInstance = this.bsInit(this.selector, window.bootstrap?.Popover)?.instance;
  }

  public closePopover(): void {
    this.popoverInstance?.hide();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-popover': Popover;
  }
}
